import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { AD_HOC_ENTRY_LABEL } from "../utils/ad-hoc-entry";

export function AdHocEntryBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "text-xs bg-purple-50 text-purple-700 border-purple-200 whitespace-nowrap",
        className,
      )}
    >
      {AD_HOC_ENTRY_LABEL}
    </Badge>
  );
}
